module.exports = "/_next/static/images/RepeatPurchaseCampaignsDesktop-4194ac775b556a38e17886a30f95f6c4.png";